import { Formik, FormikHelpers } from 'formik'
import React, { useState } from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'

import { SmartCheckbox } from 'src/components/formik/Checkbox'
import { SmartInput } from 'src/components/formik/Input'
import { Button } from 'app/components/ui/Button'
import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { sendEmmaForm } from 'src/utils/sendEmmaForm'
import { themeEstra } from 'app/styles/themeEstra'

interface Props {
  onSubmitSuccess: () => void
  initialEmailValue: string
}

const validationSchema = Yup.object().shape({
  newsletterEmail: Yup.string()
    .email('Formato non valido')
    .required('Campo obbligatorio'),
  newsletterPrivacy: Yup.bool().oneOf(
    [true],
    'Il consenso alla privacy è obbligatorio'
  ),
})

type NewsletterFormValues = {
  newsletterEmail: string
  newsletterPrivacy: boolean
}

const NewsletterModalForm: React.FC<Props> = ({
  onSubmitSuccess,
  initialEmailValue,
}) => {
  const initialValues: NewsletterFormValues = {
    newsletterEmail: initialEmailValue,
    newsletterPrivacy: false,
  }

  const [apiError, setApiError] = useState<string | null>()

  const handleSubmitError = (
    formikActions: FormikHelpers<NewsletterFormValues>
  ) => {
    formikActions.setSubmitting(true)
    setApiError(
      'Qualcosa non sta funzionando come dovrebbe, ci scusiamo e ti richiediamo di riprovare.'
    )
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        actions.setSubmitting(true)
        // post data
        sendEmmaForm({
          kind: 'newsletter',
          payload: {
            email: values.newsletterEmail,
            privacy: values.newsletterPrivacy,
          },
        })
          .then((res: { id: number }) => {
            if (res.id) {
              actions.resetForm()
              onSubmitSuccess()
            } else {
              handleSubmitError(actions)
            }
          })
          .catch(() => {
            handleSubmitError(actions)
          })
      }}
    >
      {({ handleSubmit, isSubmitting }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <FormGroupInput>
              <SmartInput
                type='email'
                name='newsletterEmail'
                label='Inserisci qui sotto la tua email'
                placeholder='email@esempio.it'
                block
                bgColor={themeEstra.color.neutri.grigioBg}
              />
            </FormGroupInput>

            <FormGroupCheckbox>
              <SmartCheckbox name='newsletterPrivacy'>
                Ho letto l&#39;
                <a
                  href='https://res.cloudinary.com/estra/image/upload/v1611750382/privacy/estra_spa/completa/informativa_newsletter_completa_sito_webEstra__ESTRASpA_rev25.01.2021.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  informativa privacy
                </a>{' '}
                e presto il consenso al trattamento dei miei dati personali per
                l’iscrizione alla newsletter con contenuto di carattere
                informativo e pubblicitario.
              </SmartCheckbox>
            </FormGroupCheckbox>

            <Button
              type='submit'
              size='lg'
              disabled={isSubmitting}
              variant='nero'
            >
              Dai, mandatemi queste newsletter…
            </Button>

            {apiError && (
              <FormFeedback variant='error'>{apiError}</FormFeedback>
            )}
          </Form>
        )
      }}
    </Formik>
  )
}

export default NewsletterModalForm

const Form = styled.form``

const FormGroupInput = styled.div`
  max-width: 236px;
  margin-bottom: 1.5rem;
`

const FormGroupCheckbox = styled.div`
  margin-bottom: 3.75rem;
`
